import React, { useId } from 'react';
import styled from 'styled-components';
import { useFootnotesService } from './use-footnote-service';
const StyledSup = styled.sup `
  font: inherit;
  vertical-align: initial;
  font-feature-settings: 'sups';
  line-height: 0;
  white-space: nowrap;
  /* This component ends up being rendered in a Nemo AEM site (https://audi.de/) which
  introduces global styles' breaking changes: https://www.audi.de/bin/nemo.static.20210217130452/cms4i-nemo/includes/core-ci/audi-core-ci-reset-and-basic.min.css
  The following workarounds are needed to make this component look identical on AEM and non AEM environments (Feature App Marketplace) */

  /* AEM workaround 1: font-size: max(1em, 16px); should be used but AEM changes the html font-size to font-size: 62.5%; */
  font-size: max(1em, 16px);

  /* AEM workaround 2: position: initial; should not be required but AEM changes the default sup tag to use position: relative; top: -5px */
  position: initial;
`;
const StyledLink = styled.a `
  && {
    border-bottom: none;
    font: inherit;
  }
`;
export function FootnoteReference({ footnoteId }) {
    const footnote = useFootnotesService(footnoteId);
    return (React.createElement(StyledSup, { className: "egt-utils-footnote" },
        React.createElement(StyledLink, { className: "egt-utils-footnote__link", href: `#${footnote?.contextID || footnoteId}`, target: "_self" }, footnote?.number === undefined ? '*' : footnote.number)));
}
export function FootnoteReferenceV2({ footnoteId, footnoteAriaLabel }) {
    const footnote = useFootnotesService(footnoteId);
    const numberSuffix = footnote?.number !== undefined ? footnote.number : '';
    return (React.createElement("sup", { className: "audi-footnote-anchor__text", translate: "no" },
        React.createElement("a", { "aria-label": footnoteAriaLabel || `footnote ${footnote?.number}`, href: `#${footnote?.contextID || footnoteId}`, id: `${footnoteId + numberSuffix}-${useId()}`, target: "_self", className: "audi-j-footnote-reference" }, footnote?.number === undefined ? '*' : footnote.number)));
}
//# sourceMappingURL=FootnoteReference.js.map